import { render, staticRenderFns } from "./listQuestionTag.vue?vue&type=template&id=42a41930&"
import script from "./listQuestionTag.vue?vue&type=script&lang=js&"
export * from "./listQuestionTag.vue?vue&type=script&lang=js&"
import style0 from "./listQuestionTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports